import React, { useEffect, useContext, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { consumeBillingCheckoutReturn, getPricingCheckoutDestination } from '../components/billing/billingPlanData';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Stripe success_url landing. Syncs checkout, then routes:
 * - Pricing/settings upgrade → /trade (?welcome=pro for Pro)
 * - Pricing downgrade → /pricing; settings downgrade → settings#billing
 * - Otherwise → onboarding (new signup / onboarding checkout)
 */
const SubscriptionSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user, refreshUserSettings } = useContext(AuthContext);
  const sessionId = searchParams.get('session_id');
  const handledRef = useRef(false);

  useEffect(() => {
    if (!user?.token || handledRef.current) {
      return;
    }
    handledRef.current = true;

    const finish = async () => {
      if (sessionId) {
        try {
          await fetch(`${BACKEND_URL}/billing/verify_session`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${user.token}`,
            },
            body: JSON.stringify({ session_id: sessionId }),
          });
        } catch (e) {
          console.error('verify_session failed:', e);
        }
      }

      if (refreshUserSettings) {
        await refreshUserSettings();
      }

      const checkoutReturn = consumeBillingCheckoutReturn();
      const pricingDest = getPricingCheckoutDestination(checkoutReturn);
      if (pricingDest) {
        navigate(pricingDest, { replace: true });
        return;
      }

      if (sessionId) {
        navigate(
          `/onboarding?stripe_sync=1&session_id=${encodeURIComponent(sessionId)}`,
          { replace: true }
        );
      } else {
        navigate('/onboarding?phase=trial_done', { replace: true });
      }
    };

    finish();
  }, [user?.token, sessionId, navigate, refreshUserSettings]);

  return (
    <div
      style={{
        minHeight: '40vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0A0D14',
        color: '#A0AEC0',
        fontSize: 14,
      }}
    >
      Continuing setup…
    </div>
  );
};

export default SubscriptionSuccess;
